module.exports = __webpack_public_path__ + "media/images/transit_ghetto_pin_new-4cbd675e.svg";